// extracted by mini-css-extract-plugin
export default {"followButton":"tR-z","followCount":"uR-z","textStyle":"vR-z"};